import {
	UntypedFormControl,
	UntypedFormGroup,
	Validators,
} from '@angular/forms';

export const CustomHubspotForm = () => {
	const emailregex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
	
	return new UntypedFormGroup({
		firstName: new UntypedFormControl('', [
			Validators.required,
			Validators.minLength(1),
			Validators.maxLength(100),
		]),
		email: new UntypedFormControl('', [
			Validators.required,
			Validators.pattern(emailregex),
		]),
		captcha: new UntypedFormControl('', [Validators.required]),
	});
};

